// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Q4v3","actions":"GroupTable_actions__3LpXr","deleteModalFooter":"GroupTable_deleteModalFooter__dzinl"};